"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_redux_1 = require("react-redux");
const useAppSelector = react_redux_1.useSelector;
exports.default = useAppSelector;
